module.exports = __webpack_public_path__ + "static/funf-49d497735621c830b21b2cff570d335f.png";